import type { Grade, ReviewOutcomes } from '@/lib/practice/grades';
import { usePersistentSession } from '@/hooks/ui/usePersistentSession';

/** Persisted flashcard run. `ratings` is keyed by CARD index (a concept can
 *  span several cards; we aggregate to one grade per concept at finish). */
export interface PersistedFlashcardSession {
  signature: string;
  index: number;
  revealed: boolean;
  ratings: Record<number, Grade>;
  completed: boolean;
  submission: 'idle' | 'done';
  /** Per-concept FSRS submit result (applied vs deduped), keyed by concept_id. */
  reviewOutcomes: ReviewOutcomes;
}

function freshFlashcardSession(signature: string): PersistedFlashcardSession {
  return {
    signature,
    index: 0,
    revealed: false,
    ratings: {},
    completed: false,
    submission: 'idle',
    reviewOutcomes: {},
  };
}

export function useFlashcardSession(
  lessonId: string,
  signature: string,
  ready: boolean
) {
  const [session, update, reset] =
    usePersistentSession<PersistedFlashcardSession>(
      `xonera:practice:flashcards:${lessonId}`,
      freshFlashcardSession,
      signature,
      ready
    );
  return { session, update, reset };
}
